export function DatalistInput({ value, onChange, options, placeholder, testid, className }) {
  const listId = `${testid}-list`;
  const opts = Array.isArray(options) ? options : [];
  return (
    <>
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        list={opts.length ? listId : undefined}
        data-testid={testid}
        className={className}
      />
      {opts.length > 0 && (
        <datalist id={listId}>
          {opts.map((o) => <option key={o.id} value={o.name} />)}
        </datalist>
      )}
    </>
  );
}

export default DatalistInput;
